import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { Register } from 'src/app/common-components/register/models/register';
import { getAccountPrivileges } from 'src/app/privileges/privileges.selector';
import { BlockedPhoneNumberFilterOptions } from './models/blocked-phone-number-filter-option';
import { BlockedPhoneNumberPrivileges } from './models/blocked-phone-number-privileges';
import { BlockedPhoneNumberRegisterOptions } from './models/blocked-phone-number-register-options';
import { BlockedPhoneNumberRegisterListItem } from './models/blocked-phone-number-register-results.model';
import {
   blockedPhoneNumberRegisterAdapterActions,
   blockedPhoneNumberRegisterInitialFilter,
   createBlockedPhoneNumber,
} from './state/blocked-phone-number-register.actions';
import * as blockedPhoneNumberRegisterReducer from './state/blocked-phone-number-register.reducer';

@Directive()
export class BlockedPhoneNumberRegister
   extends Register<BlockedPhoneNumberRegisterListItem, BlockedPhoneNumberRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: BlockedPhoneNumberFilterOptions[];

   entityName = 'Blocked Phone Number';

   blockedPhoneNumberPrivileges$: Observable<BlockedPhoneNumberPrivileges>;

   constructor(public store: Store) {
      super(store, blockedPhoneNumberRegisterReducer.selectors, blockedPhoneNumberRegisterAdapterActions);
      this.blockedPhoneNumberPrivileges$ = store.pipe(select(getAccountPrivileges));
   }

   ngOnInit() {
      this.store.dispatch(blockedPhoneNumberRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createBlockedPhoneNumber());
   }
}
